<template>
  <div>
    <h3>Thank You</h3>

    <p>
      Thank you for completing your O&ampM Project Notification Form. The total Inspection Fee for this Project Notification Form will be ${{feeAmount}}.
    </p>
    <p> The facility will be billed as follows: </p>
    <ul>
      <li> Healthcare facilities and schools shall submit a payment based off their inspections fees within 30 calendar days of the end of every calendar year 6 months period.   </li>
      <li> Commercial and industrial facilities shall submit payment within 30 calendar days of the end of every calendar year quarter.   </li>
    </ul>
    <p>At the time of billing, summary reports of work completed must be submitted with the Inspection Fees (paid via check). </p>
    <dl class="row">
      <dt class="col-12">For Customer Service:</dt>
      <dt class="col-sm-3">Hours:</dt>
      <dd class="col-sm-9">8:30am - 4:30pm</dd>
      <dt class="col-sm-3">Phone:</dt>
      <dd class="col-sm-9">312-603-8200 (and follow appropriate prompt)</dd>
    </dl>
  </div>
</template>

<script>

export default {
  name: 'OMThankYou',
  data() {
    return {
      feeAmount: '',
    };
  },
  mounted() {
    const url_string = window.location.href;
    const url = new URL(url_string);
    const c = url.hash.substring(url.hash.indexOf('=') + 1);
    this.feeAmount = c;
  },
};
</script>
